"use strict";

export default class Modal {
    constructor(selector, wrap_selector = '', options = {}) {
        if (!(selector instanceof jQuery)) {
            selector = $(selector);
        }

        if (!selector.length) {
            return;
        }

        this.wrap_selector = wrap_selector;
        this.selector = selector;
        this.options = options;
        this.request = {
            option: 'com_content',
            view: 'article',
            tmpl: 'component'
        };

        this.init();
    }

    init() {
        let $this = this,
            targetUrl = '/',
            request = this.request;

        $('body').on('click', this.selector.selector, function (e) {
            e.preventDefault();

            let $selector = $(this),
                href = $selector.data('href'),
                contentId = $selector.data('id');

            if (! contentId && !href) {
                return;
            }

            require.ensure([], require => {
                require('../libs/jquery.modal');

                const
                    defaultOptions = {
                        title: $selector.data('title') || 'Подтвердите действие',
                        setTimeout: $selector.data('timeout') || false,
                        overlay: true,
                        documentStick: false,
                        overlayClose: true
                    },
                    action = $selector.data('action');

                if ($selector.data('class')) {
                    $this.options.class = $selector.data('class');
                }

                if ($selector.data('close')) {
                    $this.options.close = $selector.data('close');
                }

                if ($selector.data('wrap')) {
                    $this.wrap_selector = $selector.data('wrap');
                }

                const options = $.extend(defaultOptions, $this.options);

                request.id = contentId;

                if (href) {
                    targetUrl = href;
                    request = {
                        tmpl: 'component'
                    };
                }

                $('<div>').load(`${targetUrl} ${$this.wrap_selector}`, request, function() {

                    let self = $(this),
                        content = self.find($this.wrap_selector);

                    content.MODAL(options);
                    
                    require('./modalHandlers').default(content, action, self, $selector);
                });

            });
        });
    }
};


// WEBPACK FOOTER //
// ./modules/modal.js